export default "__VITE_ASSET__37d1e6b8__"